/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Checkbox/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Checkbox({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/SimilarPatients/Content/Content/SimilarPerson/Lead/Info/Checkbox"
  
}) {
let selectedIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'id',
})
let similarPersonIdValueData = fromData.useDataValue({ viewPath,
context: 'similar_person',
path: 'id',
})
let aggregateData = fromAggregate.equals(selectedIdValueData, similarPersonIdValueData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<Radial
  viewPath={`${viewPath}/Radial`}
 onClick={onClick}
 data="selected.id"
 data="similar_person.id"
 aggregate="/Data/aggregate equals"
 isSelected={aggregateData}
/>
{children}
</React.Fragment>)
}